var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTranslation } from './useTranslation';
import { getDisplayName } from './utils';
export function withTranslation(ns, options) {
    if (options === void 0) { options = {}; }
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_a) {
            var forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
            var _b = useTranslation(ns, rest), t = _b[0], i18n = _b[1], ready = _b[2];
            var passDownProps = __assign(__assign({}, rest), { t: t, i18n: i18n, tReady: ready });
            if (options.withRef && forwardedRef) {
                passDownProps.ref = forwardedRef;
            }
            else if (!options.withRef && forwardedRef) {
                passDownProps.forwardedRef = forwardedRef;
            }
            return React.createElement(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(getDisplayName(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function (props, ref) {
            return React.createElement(I18nextWithTranslation, Object.assign({}, props, { forwardedRef: ref }));
        };
        return options.withRef ? React.forwardRef(forwardRef) : I18nextWithTranslation;
    };
}
export default withTranslation;
//# sourceMappingURL=withTranslation.js.map